import { booleanAttribute, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClButton } from '@corelabs/angular/ui';
import { ButtonSeverity, ButtonSize, ButtonVariant } from '../button/button.component';

@Component({
    selector: 'app-link',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.css'],
    imports: [ClButton, RouterLink],
})
export class LinkComponent {
    /** Navigation target — passed straight to routerLink. */
    readonly routerLink = input.required<string | unknown[]>();
    /** Omit for the default (normal) size. */
    readonly size = input<ButtonSize>();
    /** Color weight; omit for the default primary fill. */
    readonly severity = input<ButtonSeverity>();
    /** Outlined or text style; omit for the default filled style. */
    readonly variant = input<ButtonVariant>();
    /** Fully-rounded (pill/circle) shape. */
    readonly rounded = input(false, { transform: booleanAttribute });
    /** Square link for icon-only content; requires ariaLabel. */
    readonly iconOnly = input(false, { transform: booleanAttribute });
    /** Accessible name — required when iconOnly hides the text label. */
    readonly ariaLabel = input<string>();
}
